import { Link, useLocation } from "@tanstack/react-router";

import { SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebar } from "../ui/sidebar";
import { READER_PAGES } from "./readerPages";

/** A hosted reader's places beside their threads. */
export function SidebarReaderNav() {
  const pathname = useLocation({ select: (location) => location.pathname });
  const { isMobile, setOpenMobile } = useSidebar();
  const close = () => {
    if (isMobile) setOpenMobile(false);
  };
  return (
    <SidebarMenu className="gap-0.5">
      {READER_PAGES.map(({ to, label, icon: Icon }) => (
        <SidebarMenuItem key={to}>
          <SidebarMenuButton
            isActive={pathname.replace(/\/+$/, "") === to}
            render={<Link to={to} onClick={close} />}
            className="max-sm:h-10"
          >
            <Icon />
            <span>{label}</span>
          </SidebarMenuButton>
        </SidebarMenuItem>
      ))}
    </SidebarMenu>
  );
}

/** A quiet heading over a run of threads. */
export function SidebarSectionHeading({ label }: { label: string }) {
  return (
    <li className="mx-0.5 mt-3 flex h-7 list-none items-center gap-2 px-2.5 text-sidebar-muted-foreground text-xs">
      {label}
    </li>
  );
}
